"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MergeStylesShadowRootConsumer = void 0;
var merge_styles_1 = require("@fluentui/merge-styles");
var useMergeStylesHooks_1 = require("../hooks/useMergeStylesHooks");
var useMergeStylesShadowRoot_1 = require("../hooks/useMergeStylesShadowRoot");
var MergeStylesShadowRootConsumer = function (_a) {
    var stylesheetKey = _a.stylesheetKey, children = _a.children;
    var _b = (0, useMergeStylesHooks_1.useMergeStylesHooks)(), useAdoptedStylesheetEx = _b.useAdoptedStylesheetEx, useMergeStylesRootStylesheets = _b.useMergeStylesRootStylesheets, useWindow = _b.useWindow;
    var shadowCtx = (0, useMergeStylesShadowRoot_1.useMergeStylesShadowRootContext)();
    var rootMergeStyles = useMergeStylesRootStylesheets();
    var win = useWindow();
    useAdoptedStylesheetEx(merge_styles_1.GLOBAL_STYLESHEET_KEY, shadowCtx, rootMergeStyles, win);
    useAdoptedStylesheetEx(stylesheetKey, shadowCtx, rootMergeStyles, win);
    return children(!!shadowCtx);
};
exports.MergeStylesShadowRootConsumer = MergeStylesShadowRootConsumer;
//# sourceMappingURL=MergeStylesShadowRootConsumer.js.map